<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-qrcode</v-icon>{{$t('profile.material.products')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <MaterialProductForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import MaterialProductForm from '../../components/materialproduct/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'MaterialProduct';

const { mapFields } = createHelpers({
  getterType: 'materialproduct/getField',
  mutationType: 'materialproduct/updateField'
});

export default {
  name: 'MaterialProductCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    MaterialProductForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('materialproduct', ['create', 'reset'])
  }
};
</script>
